/*
* Some hacks for the valu search compatibility.
*/

export default function () {
    (function (window, document, $) {
        $(function () {
            let search_opened_fresh = false;
            let ui_catchup_delay = 250;

            if(window.location.hash.match(/^#q/)) {
                search_opened_fresh = false;
                $('body').addClass('js-search-open');
            }

            window.onhashchange = function () {
                setTimeout(function () {
                    if(!search_opened_fresh && !window.location.hash.match(/^#q/))  {
                        $('body').removeClass('js-search-open');
                    }
                }, ui_catchup_delay);
            }

            $('.js-search-toggle').on('click', function () {
                if($('body').hasClass('valu-search-open')) {
                    search_opened_fresh = true;
                    window.location.hash = "#";
                } else {
                    window.location.hash = "#q=" + encodeURI($('.js-search-field').val());
                    setTimeout(function () {
                        $('.js-search-field').triggerHandler( "focus" );
                    }, ui_catchup_delay);
                }

                $('body').toggleClass('js-search-open');
            });
        });
    })(window, document, jQuery);
}



// WEBPACK FOOTER //
// ./js/regular/valu-search.js